import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReactSimpleDropdown, {
  DropdownTrigger,
  DropdownContent,
} from 'react-simple-dropdown';

export default class SortingMenu extends Component {
  static propTypes = {
    className: PropTypes.string,
    trigger: PropTypes.node,
    inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    children: PropTypes.node,
  };

  render() {
    const { className, trigger, children } = this.props;

    return (
      <ReactSimpleDropdown className={className} ref={this.props.inputRef}>
        <DropdownTrigger data-test="dropdown-trigger">
          {trigger}
        </DropdownTrigger>
        <DropdownContent data-test="dropdown-content">
          {children}
        </DropdownContent>
      </ReactSimpleDropdown>
    );
  }
}
